import React from 'react'

const Game = () => {
  return (
    <>
    <div className='gaming-code'>
    <div className='gaming'>
      <h1>Code Game</h1>
       <h2>Help the Lynx collect pine cones!</h2>
   </div>
<div className='game-image'>
    <img src='https://www.w3schools.com/images/w3lynx_200.webp'></img>
   </div>
<div className='game-btn'>
    <div className='play-btn'>Play Game</div>
</div>
   </div>
    </>
  );
}

export default Game;                             